
export interface messagefromComponent {
    codeMessage: number
    descrMessage?: string
    traceMessage: string
    detailsMessage?: string
    destComponent?: string
    value?:any
    Data?: {
        Items: Array<any>
    }
}

export class anagraficaData {
    id: any; //ID tipo path 0 se in insert
    nomeTabRif: string; // Nome API 
    dati?:any // dati in formato json 
    masterKey?: string; // la chiave ed id oppure ISTAT per i comuni
    filter: any; //Filtro querystring
    inviaA: string; //Componente padre che chiama l'anagrafica
    SubjectCall: string; //Il service di form-templateService
    tipo: string;  //Tipo Form
    displayExpr:string ;  // Titolo
    toolbarComponent?:{ //Particolari indicazioni per la toolbar Verticale
    componentName?:string;
    stato:boolean
    }[]
}[]


export interface httResponse {
    codeMessage: number
    descrMessage: string
    traceMessage: string
    detailsMessage: string
    Data?: {
        Items?: Array<any>
    }
}

export class Menu {

    text?: string;
    icon?: string;
    visible?: boolean;
    disabled?: boolean;
    image?: string;
    id?: number;
    items?: Array<any>

}

export class Breadcrumb {
    label: string;
    url: string;
}
export interface AnagraficaNavigations {

    
    
    idTab:string
    data:{
        id:any,
        title:string;
        cRouter :string;
        params:any[];
        currentComponent: string;
        activeCurrent:boolean;
        idGroup?:any,
        items?:any[];
    }[]
    
    

}

export interface CustomNavigation {
    title: string;
    component:string;
    event:string;
    id: number;
  }
  

export interface TAB {
    id: number;
    title: string;
    icon: string;
    component: string;
    data?: any[];
    paramsUrl?:any
}

export interface TABPANEL {
    tabIndex: number;
    name: string;
    dati: TAB[];
    action: string

}

export interface FORMULARIO{
    identificativoSito:string;
    datiFormulario:DATIFORMULARIO;
    datiTrasportoPartenza?:DATITRASPORTOPARTENZA;

}


export interface DATIFORMULARIO {


    numeroFIR?: string;
    dataEmissione?: string;
    produttoreDetentore?: {
        identificativoSito?: string;
        indirizzo?: {
            siglaProvincia?: string;
            provincia?: string;
            paese?: {
                id?: string;
                nome?: string
            },
            cap?: string;
            citta?: string;
            localita?: string;
            via?: string;
            civico?: string;
            paeseId?: string;
            comuneIstat?: string
        },
        codiceFiscalePaese?: {
            paeseId?: string;
            codiceFiscale?: string
        },
        cuu?: string;
        denominazione?: string;
        contatto?: {
            nome?: string;
            cognome?: string;
            telefono?: string;
            email?: string
        },
        luogoProduzione?: {
            paeseId?: string;
            comuneIstat?: string;
            cap?: string;
            citta?: string;
            localita?: string;
            via?: string;
            civico?: string
        },
        autorizzazioneRS?: {
            numero?: string;
            data?: string;
        }
    },

    /****************************/

    trasportatori?: [
        {
            identificativoSito?: string;
            idTrasportatore?: number,
            codiceFiscalePaese?: {
                paeseId?: string;
                codiceFiscale?: string
            },
            denominazione?: string;
            indirizzo?: {
                siglaProvincia?: string;
                provincia?: string;
                paese?: {
                    id?: string;
                    nome?: string
                },
                cap?: string;
                citta?: string;
                localita?: string;
                via?: string;
                civico?: string;
                paeseId?: string;
                comuneIstat?: string
            },
            contatto?: {
                nome?: string;
                cognome?: string;
                telefono?: string;
                email?: string
            },
            autorizzazioneAlbo?: {
                numeroIscrizione?: string;
                dataIscrizione?: string
            }
        }
    ],
    /****************************/
    destinatario?: {
        indirizzo?: {
            siglaProvincia?: string;
            provincia?: string;
            paese?: {
                id?: string;
                nome?: string
            },
            cap?: string;
            citta?: string;
            localita?: string;
            via?: string;
            civico?: string;
            paeseId?: string;
            comuneIstat?: string
        },
        codiceFiscalePaese?: {
            paeseId?: string;
            codiceFiscale?: string
        },
        denominazione?: string;
        contatto?: {
            nome?: string;
            cognome?: string;
            telefono?: string;
            email?: string
        },
        autorizzazioneRS?: {
            numero?: string;
            data?: string
        }
    },
    /****************************/
    dataFirma?: string;
    denominazioneFirmatario?: string;
    identificativoFirmatario?: string;
    intermediari?: [
        {
            codiceFiscalePaese?: {
                paeseId?: string;
                codiceFiscale?: string
            },
            denominazione?: string;
            indirizzo?: {
                siglaProvincia?: string;
                provincia?: string;
                paese?: {
                    id?: string;
                    nome?: string
                },
                cap?: string;
                citta?: string;
                localita?: string;
                via?: string;
                civico?: string;
                paeseId?: string;
                comuneIstat?: string
            },
            contatto?: {
                nome?: string;
                cognome?: string;
                telefono?: string;
                email?: string
            }
        }
    ],
    caratteristicheRifiuto?: {
        codiceEer?: string;
        statoFisico?: string;
        descrizioneRifiuto?: string;
        caratteristicheChimicoFisiche?: string;
        classiPericolo?: [],
        numeroColli?: string;
        tipoImballaggio?: string
    },
    destinazioneRifiuto?: [
        string
    ],
    quantitaRifiuto?: {
        quantita?: {
            um?: string;
            valore?: 0
        },
        tara?: 0,
        pesoLordo?: 0,
        verificareADestino?: true
    },
    percorso?: string;
    normativaADR?: {
        numeroONU?: string;
        classeADR?: string;
        gruppoImballaggio?: string;
        noteADR?: string
    },
    annotazioni?: string
}[]


export interface DATITRASPORTOPARTENZA {
    idTrasportatore?: number;
    conducente?: {
        nome?: string;
        cognome?: string
    },
    targaAutomezzo?: string;
    targaRimorchio?: string;
    dataInizioTrasporto?: string;
    oraInizioTrasporto?: string;
    annotazioni?: string
}[]

export interface DATIACCETTAZIONE{

  denominazioneFirmatario?: string;
  identificativoFirmatario?:string;
  dataFirma?: string;
  accettazioneCompleta?: string;
  quantitaAccettata?: {
    um: string,
    valore: number
  };
  motivazioniRespingimento?: string;
  dataAccettazione?: Date;
  oraAccettazione?: string;
  annotazioni?: string
}[]